import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './Appointment.html?raw';
import "../../GenericDialog/GenericDialog";

class Appointment extends compose(_WidgetBaseSP) {
    templateString: any = template;


    private heading: HTMLElement;
    private appointmentDescriptionContainer: HTMLSpanElement;

    setEntity(appointment: more.EntityAPIResult, title?: string) {
        this.UiModder.domConstruct.empty(this.heading);
        this.UiModder.domConstruct.empty(this.appointmentDescriptionContainer);

        if (title) this.UiModder.domAttr.set(this.heading, "innerHTML", title);

        if (appointment) {
            for (let key in appointment) {
                if (key == "ID") {
                    this.domNode.style.setProperty("entityID", appointment.ID);
                } else if (key == "Classname") {
                    this.UiModder.domClass.add(this.domNode, appointment.Classname);
                } else {
                    let keyContainer = this.UiModder.domConstruct.create("div", {

                    }, this.appointmentDescriptionContainer);

                    let label = this.UiModder.domConstruct.create("label", {
                        innerHTML: this.translate("General_Label_" + appointment.Classname + "_" + key)
                    }, keyContainer);

                    let content = this.UiModder.domConstruct.create("div", {
                        innerHTML: appointment[key]
                    }, keyContainer);
                }
            }
        }
        
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(Appointment);